<template>
  <v-navigation-drawer theme="" permanent align-tabs="center">    
      <v-list-item title="" class="text-h6">Filter Churches</v-list-item>
    <v-list color="transparent">
    <!-- Layer Selection -->
     <v-list-item>
        <v-radio-group
          v-model="selectedLayer"
          @update:modelValue="onLayerChange"
          :mandatory="true"
          label="Select Layer"
          class="layer-radio-group"
        >
      <v-radio 
        v-for="option in getLayerOptions"
        :key="option.value"
        :label="option.label"
        :value="option.value"
        :disabled="option.disable" 
        ripple="false" 
        class="no-hover" 
      ></v-radio>
      </v-radio-group>
      </v-list-item>

    </v-list>

      <v-divider></v-divider>


      <v-expansion-panels
      v-model="panel"
      :disabled="disabled"
      multiple
    >
    <!-- first group -->
    <v-expansion-panel>
        <v-expansion-panel-title class="text-button">Place Filters</v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-autocomplete
          ref="selectedPlacenameRef"          
          v-if="getChurchname"
          v-model="selectedPlacename"
          :items="getChurchname"
          label="Church and Place Name"
          @update:modelValue="(value) => onGroupTwoChange(['selectedPlacename',value, 'Church Name (Modern)'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>

          </v-expansion-panel-text>
          </v-expansion-panel>

<!-- second group -->
        <v-expansion-panel>
        <v-expansion-panel-title class="text-button">Location Filters</v-expansion-panel-title>
        <v-expansion-panel-text>
          <!-- {{ getCountries }} -->
            <v-autocomplete
          
          v-if="getCountries.length > 0"
          v-model="selectedCountry"
          :items="getCountries"
          label="Country"
          @update:modelValue="onCountryChange"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>
   
        <v-autocomplete
          
          v-if="getStates.length > 0"
          v-model="selectedState"
          :items="getStates"
          label="Modern State"
          @update:modelValue="onStateChange"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>
     
        <v-autocomplete          
          v-if="getDistricts.length > 0"
          v-model="selectedDistrict"
          :items="getDistricts"
          label="Modern District"
          @update:modelValue="(value) => filterGeojson([value, 'Modern District/County (Landeskreis/Bezirk)'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>
      
        </v-expansion-panel-text>
      </v-expansion-panel>

      <v-expansion-panel>
      <v-expansion-panel-title class="text-button">Data Filters</v-expansion-panel-title>
        <v-expansion-panel-text>
          
          <!-- Third Group -->
           
      
        <v-autocomplete
          ref="selectedPlacenameRef"
          
          v-if="getModernplace"
          v-model="selectedPlacename"
          :items="getModernplace"
          label="Modern Place"
          @update:modelValue="(value) => onGroupTwoChange(['selectedPlacename',value, 'Modern Placename'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>
            
        <v-autocomplete
          v-if="getSecular"
          v-model="selectedSecular"
          :items="getSecular"
          label="Secular Ruler"
          @update:modelValue="(value) => onGroupTwoChange(['selectedSecular',value, 'Secular Ruler,  Early Modern'])"
          clearable
          clear-icon="mdi-close"
          variant="outlined"
          density="compact"
          @click:clear="resetMap"
        ></v-autocomplete>
      
        <v-autocomplete
          ref="selectedBishopRef"
          variant="outlined"
          v-if="getBishop"
          v-model="selectedBishop"
          :items="getBishop"
          label="Bishop"
          @update:modelValue="(value) => onGroupTwoChange(['selectedBishop',value, 'Bishop (Early Modern)'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          density="compact"
        ></v-autocomplete>
      

      
        <v-autocomplete
          ref="selectedArchbishopRef"
          
          v-if="getArchbishop"
          v-model="selectedArchbishop"
          :items="getArchbishop"
          label="Archbishop"
          @update:modelValue="(value) => onGroupTwoChange(['selectedArchbishop',value, 'Archbishop (Early Modern)'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>
      

      
        <!-- <v-autocomplete
          ref="selectedChurchnameRef"
          
          v-if="getChurchname"
          v-model="selectedChurchname"
          :items="getChurchname"
          label="Church Name"
          @update:modelValue="(value) => onGroupTwoChange(['selectedChurchname',value, 'Church Name (Modern)'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete> -->
      

      
        <v-autocomplete
          ref="selectedTypesharingRef"
          
          v-if="getTypesharing"
          v-model="selectedTypesharing"
          :items="getTypesharing"
          label="Church Sharing Type"
          @update:modelValue="(value) => onGroupTwoChange(['selectedTypesharing',value, 'church sharing type'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>
      <!-- 
        <v-text-field
          ref="selectedTypesharingRef"
          v-if="getTypesharing"
          v-model="selectedTypesharing"
          label="Type Sharing"
          @input="(value) => onGroupTwoChange(['selectedTypesharing', value, 'Type of Sharing'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-text-field> -->

        <!-- 
        Custom text field search. Uncomment this line
        <v-text-field
          ref="selectedTypesharingRef"
          v-if="getTypesharing"
          v-model="selectedTypesharing"
          label="Type of Sharing"
          @keyup.enter="handleEnterKey"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-text-field> -->

      
        <v-autocomplete
          ref="selectedCongregatRef"
          
          v-if="getCongregat"
          v-model="selectedCongregat"
          :items="getCongregat"
          label="Num of Confessions"
          @update:modelValue="(value) => onGroupTwoChange(['selectedCongregat',value, 'Number of congregations'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>
      

      
        <v-autocomplete
          ref="selectedSharingRef"
          
          v-if="getSharing"
          v-model="selectedSharing"
          :items="getSharing"
          label="Confession Sharing"
          @update:modelValue="(value) => onGroupTwoChange(['selectedSharing',value, 'confessions (denominations) sharing church'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>

        <!-- Fix below getters and variable-->
        <v-autocomplete
          ref="selectedSharingRef"          
          v-if="getLocationtype"
          v-model="selectedLocationType"
          :items="getLocationtype"
          label="Location Type"
          @update:modelValue="(value) => onGroupTwoChange(['selectedSharing',value, 'Location type (Early Modern)'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>

        <v-autocomplete
          ref="selectedSharingRef"          
          v-if="getRGroups"
          v-model="selectedRGroups"
          :items="getRGroups"
          label="Remaining Groups in Church"
          @update:modelValue="(value) => onGroupTwoChange(['selectedSharing',value, 'Continuing Denominations'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>

        <!-- <v-autocomplete
          ref="selectedSharingRef"
          
          v-if="getSharing"
          v-model="selectedSharing"
          :items="getSharing"
          label="Confession Sharing"
          @update:modelValue="(value) => onGroupTwoChange(['selectedSharing',value, 'confessions (denominations) sharing church'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete> 
        -->

        <v-autocomplete
          ref="selectedSharingRef"
          
          v-if="getParishSaint"
          v-model="selectedParishSaint"
          :items="getParishSaint"
          label="Parish Saint"
          @update:modelValue="(value) => onGroupTwoChange(['selectedSharing',value, 'Parish Saint (historical)'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>



        <!-- @update:modelValue="(value) => onGroupTwoChange(['selectedSharing',value, 'Sharing: Catholics (Roman Catholic, Alt Catholic, Orthodox'])" -->

<!--       
        <v-autocomplete
          ref="selectedProtestantRef"
          
          v-if="getProtestant"
          v-model="selectedProtestant"
          :items="getProtestant"
          label="Protestant"          
          @update:modelValue="(value) => onGroupTwoChange(['selectedProtestant',value, 'Protestant Groups'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete> -->

        <!-- @update:modelValue="(value) => onGroupTwoChange(['selectedProtestant',value, 'Protestants (Lutherans Reformed/Zwinglian Evangelisch Libertine'])" -->
   

        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- fourth group 
      getSharingst: (state) => state.sharingst,
      getSharingend 
      -->

      <v-expansion-panel>
        <v-expansion-panel-title class="text-button">Date Filters</v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-autocomplete
          ref="selectedDateStarted"          
          v-if="getSharingst"
          v-model="selectedDateStarted"
          :items="getSharingst"
          label="Start Date"
          @update:modelValue="(value) => onGroupThreeChange(['selectedPlacename',value, 'Date sharing Started (de facto)'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>

          <v-autocomplete
          ref="selectedDateEnded"          
          v-if="getSharingend"
          v-model="selectedDateEnded"
          :items="getSharingend"
          label="End Date"
          @update:modelValue="(value) => onGroupThreeChange(['selectedPlacename',value, 'Date sharing Ended (de facto)'])"
          clearable
          clear-icon="mdi-close"
          @click:clear="resetMap"
          variant="outlined"
          density="compact"
        ></v-autocomplete>

          </v-expansion-panel-text>
          </v-expansion-panel>

      </v-expansion-panels>

      <!-- First Group -->
       <!-- {{ getCountries }} -->
      

      <!-- <v-divider></v-divider> -->

      
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import SrchClassrooms from "./SrchClassrooms.vue";
import SrchEquipment from "./SrchEquipment.vue";
import countriesData from "@/assets/CountryState.json"; //replace countriesData to countriesDataB
import countriesDataB from "@/assets/CountryStateB.json";

export default {
  data: () => ({
    panel: [0],
    items: null,
    selectedCountry: null,
    selectedState: null,
    selectedDistrict: null,
    selectedPlacename: null,
    selectedSecular: null,
    selectedBishop: null,
    selectedArchbishop: null,
    selectedChurchname: null,
    selectedTypesharing: null,
    selectedCongregat: null,
    selectedSharing: null,
    selectedProtestant: null,
    selectedDateStarted: null,
    selectedDateEnded: null,
    selectedLocationType: null,
    selectedRGroups: null,
    selectedParishSaint: null,
    // countries: countriesData,
    layerOptions: ["Churches A", "Churches B", "Churches C"], // Options for the new selection box

  }),

  computed: {
     // Map Vuex state to get layer options and selected layer
    //  getLayerOptions() {
    //   return this.$store.state.layerOptions;
    // },
    // selectedLayer: {
    //   get() {
    //     return this.$store.state.selectedLayer;
    //   },
    //   set(newValue) {
    //     // Dispatch mutation to update the selected layer in Vuex
    //     this.$store.commit('setSelectedLayer', newValue);
    //   }
    // },

    getCountries() {
        return this.getCountriesStateFile
          .map((country) => country.name)
          .sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' })); // Sort alphabetically
      },
    getStates() {
      if (this.selectedCountry) {
        const country = this.getCountriesStateFile.find(
          (country) => country.name === this.selectedCountry
        );
        return country ? country.states
        .map((state) => state.name)
        .sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' })) : []; // Sort alphabetically
      }
      return [];
    },
    
    getDistricts() {
      if (this.selectedCountry && this.selectedState) {
        const country = this.getCountriesStateFile.find(
          (country) => country.name === this.selectedCountry
        );
        const state = country.states.find(
          (state) => state.name === this.selectedState
        );
        return state ? state.districts.sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' })) : []; // Sort alphabetically
      }
      return [];
    },

    ...mapState({
      stateActiveTab: "activeTab",
      stateTestString: "testString",
      stateIsDrawerOpen: "isDrawerOpen",
    }),
    ...mapGetters({
      getCountry: "getCountry",
      getLayerOptions: "getLayerOptions", // Get layer options from the store
      selectedLayer: "getSelectedLayer",  // Get selected layer from the store
      getProjID: "getProjID",
      getModernplace: "getModernplace",
      getSecular: "getSecular",
      getBishop: "getBishop",
      getArchbishop: "getArchbishop",
      getChurchname: "getChurchname",
      getTypesharing: "getTypesharing",
      getCongregat: "getCongregat",
      getSharing: "getSharing",
      getProtestant: "getProtestant",
      getCountriesStateFile: "getCountriesStateFile",
      getIsDrawerOpen: "getIsDrawerOpen",
      getCountry: "getCountry",

      getLocationtype: "getLocationtype",
      getRGroups: "getRGroups",
      getParishSaint: "getParishSaint",

      getSharingst: "getSharingst",
      getSharingend: "getSharingend"

      // getChb3: "getChb3",
      // getChb4: "getChb4"
    }),
  },

  components: {
    SrchClassrooms,
    SrchEquipment,
  },

  methods: {

    isRadioDisabled(option) {
      // Example: disable Layer 2
      return option.value === 'ChurchesA';
    },

    handleEnterKey() {
    if (this.selectedTypesharing) {
      this.$store.dispatch('filterGeojsonStandBy', [
        this.selectedTypesharing,
        'Type of Sharing' // or the appropriate filter property
        ]);
      }
    },
    
    onLayerChange(value) {
      console.log("Layer is ::",value)
      this.SET_LAYER(value); // Use the Vuex mutation to update the selected layer
      this.resetGroup1();
      this.resetGroup2();
      this.resetMap();
      this.extractProjIds();
    },

    onCountryChange(value) {
      this.selectedCountry = value;
      this.selectedState = null;
      this.selectedDistrict = null;
      this.clearGroup2('all')
      this.clearGroup3('all')    
      this.filterGeojson([value, "Modern Country"]);
    },
    onStateChange(value) {
      this.selectedState = value;
      this.selectedDistrict = null;
      this.filterGeojson([value, "Modern State (Bundesland/Département/Canton/Province)"]);
    },  

    onGroupTwoChange(val) {

      console.log("val::", val)
      this.selectedCountry = null;
      this.selectedState = null;
      this.selectedDistrict = null;

      this.filterGeojson([val[1], val[2]]);

      this.clearGroup2(val[0]) 
      this.clearGroup3('all')    
      
      // this.resetMap();
    },

    onGroupThreeChange(val) {

      console.log("val::", val)
      this.selectedCountry = null;
      this.selectedState = null;
      this.selectedDistrict = null;

      this.filterGeojson([val[1], val[2]]);

      this.clearGroup2('all')     

      // this.resetMap();
      },

    clearGroup2(val){
       // List of all the fields
       const allFields = [
        "selectedPlacename",
        "selectedSecular",
        "selectedBishop",
        "selectedArchbishop",
        "selectedChurchname",
        "selectedTypesharing",
        "selectedCongregat",
        "selectedSharing",
        "selectedProtestant",
        "selectedLocationType",
        "selectedRGroups",
        "selectedParishSaint",

        // Groupd three below
        // "selectedDateStarted",
        // "selectedDateEnded"
      ];

      // Reset all fields except the one that was selected
      allFields.forEach(field => {
        if (field !== val) {
          this[field] = null;
        }
      });
    },

    clearGroup3(val){
       // List of all the fields
       const allFields = [        
        // Groupd three below
        "selectedDateStarted",
        "selectedDateEnded"
      ];

      // Reset all fields except the one that was selected
      allFields.forEach(field => {
        if (field !== val) {
          this[field] = null;
        }
      });
    },

    resetGroup1() {
      this.selectedCountry = null;
      this.selectedState = null;
      this.selectedDistrict = null;
    },

    resetGroup2() {
      this.selectedPlacename = null;
      this.selectedSecular = null;
      this.selectedBishop = null;
      this.selectedArchbishop = null;
      this.selectedChurchname = null;
      this.selectedTypesharing = null;
      this.selectedCongregat = null;
      this.selectedSharing = null;
      this.selectedProtestant = null;
      this.selectedLocationType= null;
      this.selectedRGroups= null;
      this.selectedParishSaint= null;
      

      // reset Group3 in the same method
      this.selectedDateStarted = null;
      this.selectedDateEnded = null
    },

    second(val){
      console.log("Second", val[0], val[1])
    },
    ...mapMutations(["SET_ACTIVE_TAB","SET_LAYER"]),
    ...mapActions(["filterGeojson", "resetMap","extractProjIds","filterGeojsonStandBy"]),
  },
};
</script>

<style scoped>
.fancy-autocomplete .v-input__control {
 
}
.fancy-autocomplete .v-label {
  
}

>>>.v-selection-control__input input {
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
     opacity: 100 ; 
}

.v-selection-control--density-default {
  --v-selection-control-size:20px
}

/* .layer-radio-group .v-radio {
  margin-bottom: 12px;
  color: white; 
}

.layer-radio-group {
  padding: 10px;
  background-color: #0C234B; 
} */

>>>.v-selection-control .v-label {
  padding-left: 10px !important
}
</style>
<style>
/* Custom class to disable hover effect */
.no-hover:hover {
  background-color: transparent; /* Remove background change on hover */
  cursor: default; /* Optional: Change cursor to default */
}

</style>